/** @description always include jQuery in this manner in every file where jQuery is used */
const $ = jQuery.noConflict();

'use strict';

const FollowBtn = {

	$domFollowCompanyBtn: $('.js-follow-company'),
	$domFollowUserBtn: $('.js-follow-user'),
	$domFollowText: $('.js-follow-text'),
	classFollow: 'is-following',
	textFollowing: 'Pratim',
	textNotFollowing: 'Prati',

	/**
	 * @description Initialize
	 */
	init: function() {
		this.bindEvents();
	},

	bindEvents: function() {
		this.$domFollowCompanyBtn.on('click', this.followCompany);
		this.$domFollowUserBtn.on('click', this.followUser);
	},

	/**
	 * @description Handles following/unfollowing a company
	 */
	followCompany: async function(event) {
		event.preventDefault();

		const $button = $(this);
		const userId = $button.data('user-id');
		const companyId = $button.data('company-id');

		// if (!userId || !companyId) {
		// 	console.error('User ID or Company ID is missing');
		// 	return;
		// }
		console.log(window.apiSettings.token);
		try {
			const response = await fetch(`${window.origin}/wp-json/office-pulse-api/v1/company/toggle-subscriber`, {
				method: 'POST',
				headers: {
					'Content-Type': 'application/json',
					'Authorization': `Bearer ${window.apiSettings.token}`
				},
				body: JSON.stringify({
					user_id: userId,
					company_id: companyId
				})
			});

			const result = await response.json();

			if (!response.ok) {
				console.error(result.error || 'Something went wrong');
				return;
			}

			// Update button state based on the result
			if ($button.hasClass(FollowBtn.classFollow)) {
				$button.removeClass(FollowBtn.classFollow);
				FollowBtn.$domFollowText.text(FollowBtn.textNotFollowing);
			} else {
				$button.addClass(FollowBtn.classFollow);
				FollowBtn.$domFollowText.text(FollowBtn.textFollowing);
			}

			console.log(result.message);

		} catch (error) {
			console.error('Error:', error);
		}
	},

	followUser: async function(event) {
		event.preventDefault();

		const $button = $(this);
		const userId = $button.data('user-id');
		const targetUserId = $button.data('target-user-id');

		// if (!userId || !companyId) {
		// 	console.error('User ID or Company ID is missing');
		// 	return;
		// }
		console.log(window.apiSettings.token);
		try {
			const response = await fetch(`${window.origin}/wp-json/office-pulse-api/v1/user/toggle-follower`, {
				method: 'POST',
				headers: {
					'Content-Type': 'application/json',
					'Authorization': `Bearer ${window.apiSettings.token}`
				},
				body: JSON.stringify({
					user_id: userId,
					target_user_id: targetUserId
				})
			});

			const result = await response.json();

			if (!response.ok) {
				console.error(result.error || 'Something went wrong');
				return;
			}

			// Update button state based on the result
			if ($button.hasClass(FollowBtn.classFollow)) {
				$button.removeClass(FollowBtn.classFollow);
				FollowBtn.$domFollowText.text(FollowBtn.textNotFollowing);
			} else {
				$button.addClass(FollowBtn.classFollow);
				FollowBtn.$domFollowText.text(FollowBtn.textFollowing);
			}

			console.log(result.message);

		} catch (error) {
			console.error('Error:', error);
		}
	}
};

export default FollowBtn;
